(() => {
  const root = window.Shopify?.routes?.root || '/';
  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: 'USD' }).format(cents / 100);
  document.querySelectorAll('[data-commerce-form]').forEach(form => {
    if(form.dataset.initialized) return;
    form.dataset.initialized = 'true';
    const strings = JSON.parse(form.querySelector('[data-commerce-strings]').textContent);
    form.querySelector('[data-native-selector]').hidden = true;
    const variants = JSON.parse(form.querySelector('[data-commerce-variants]').textContent);
    const id = form.querySelector('[data-variant-id]');
    const qty = form.querySelector('[name="quantity"]');
    const status = form.querySelector('[data-cart-status]');
    const add = form.querySelector('[data-add-to-cart]');
    const buy = form.querySelector('[data-buy-now]');
    const choices = () => Array.from(form.querySelectorAll('input[data-option-index]:checked')).sort((a,b)=> +a.dataset.optionIndex - +b.dataset.optionIndex).map(i => i.value);
    let selected;
    function sync() {
      const values = choices();
      selected = variants.find(v => v.options.every((x,i) => x === values[i]));
      id.value = selected?.id || '';
      form.querySelector('[data-current-price]').textContent = selected ? money(selected.price) : strings.unavailable;
      add.disabled = buy.disabled = !selected?.available;
      add.firstChild.textContent = selected?.available ? strings.add_to_cart+' ' : strings.unavailable+' ';
      form.querySelectorAll('[data-size-price]').forEach(el => {
        const v = variants.find(v => v.options[0] === values[0] && v.options[1] === el.dataset.sizePrice);
        el.textContent = v ? money(v.price) : strings.unavailable;
      });
      const bulk=form.querySelector('[data-bulk-link]');
      if(bulk){const url = new URL(bulk.href);const params=new URLSearchParams(url.hash.slice(1));params.set('format',values[0]);url.search='';url.hash=params.toString();bulk.href=url.href;}
      const url = new URL(location.href);if(selected)url.searchParams.set('variant',selected.id);history.replaceState({},'',url);
    }
    form.addEventListener('change',e=>{if(e.target.matches('[data-option-index]'))sync();});
    form.querySelectorAll('[data-quantity-step]').forEach(button=>button.addEventListener('click',()=>{qty.value=Math.min(999,Math.max(1,(parseInt(qty.value,10)||1)+Number(button.dataset.quantityStep)));}));
    async function addItem(checkout) {
      if(!selected?.available || !form.reportValidity())return;
      add.disabled=buy.disabled=true;status.textContent=strings.adding;
      try {
        if (typeof window.AdlCartDrawer?.add === 'function') {
          const added = await window.AdlCartDrawer.add(selected.id,parseInt(qty.value,10)||1,{trigger:checkout?buy:add,open:!checkout});
          if (!added) return;
        } else {
          const response = await fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:selected.id,quantity:parseInt(qty.value,10)||1}]})});
          const data = await response.json();if(!response.ok)throw new Error(data.description || strings.failed);
          const cart = await fetch(root+'cart.js').then(r=>r.json());document.querySelectorAll('[data-cart-count]').forEach(el=>el.textContent=cart.item_count);
        }
        if(checkout){location.assign(root+'checkout');return;}
        status.textContent=strings.added;form.querySelector('[data-view-cart]').hidden=false;
      } catch(error) {status.textContent=error.message || strings.error;}
      finally {add.disabled=buy.disabled=!selected?.available;}
    }
    form.addEventListener('submit',e=>{e.preventDefault();addItem(false);});buy.addEventListener('click',()=>addItem(true));sync();
  });
})();
document.querySelectorAll('[data-bulk-fragrance]').forEach(input=>{const q=new URLSearchParams(location.hash.includes('fragrance=')?location.hash.slice(1):location.search);input.value=q.get('fragrance')||'';const format=input.form.querySelector('[data-bulk-format]');if(format&&['Pure Fragrance Oil','Ready-Made Perfume'].includes(q.get('format')))format.value=q.get('format');});

document.querySelectorAll('[data-inquiry-login]').forEach(link=>{if(location.hash.includes('fragrance='))link.href='/customer_authentication/login?return_to='+encodeURIComponent(location.pathname+location.search+location.hash);});
